
import { BookingFormData } from "../../ParcelBookingForm";
import { BookingDetails } from "@/hooks/bookings/types";

export const transformFormDataToBookingDetails = (formData: BookingFormData): BookingDetails => {
  // Transform contacts from form data to booking details format
  const collectionContacts = formData.collectionContacts.map(contact => ({
    name: contact.isMyself ? 'Myself' : contact.name,
    phone: contact.phone,
    email: contact.email || undefined,
  }));

  const deliveryContacts = formData.deliveryContacts.map(contact => ({
    name: contact.isMyself ? 'Myself' : contact.name,
    phone: contact.phone,
    email: contact.email || undefined,
  }));

  return {
    id: 'preview',
    user_id: 'preview',
    org_id: null,
    status: 'pending',
    created_at: new Date().toISOString(),
    collection_datetime: formData.collectionDateTime,
    payment_confirmed: false,
    payment_confirmed_at: null,
    payment_confirmed_by: null,
    payment_url: null,
    tracking_url: null,
    total_parcels_count: formData.parcels.reduce((sum, parcel) => sum + parcel.quantity, 0),
    
    // Transform addresses
    collection_address: {
      street: formData.collectionAddress.street,
      street2: formData.collectionAddress.street2,
      city: formData.collectionAddress.city,
      province: formData.collectionAddress.province,
      postal_code: formData.collectionAddress.postalCode,
      country: formData.collectionAddress.country,
    },
    delivery_address: {
      street: formData.deliveryAddress.street,
      street2: formData.deliveryAddress.street2,
      city: formData.deliveryAddress.city,
      province: formData.deliveryAddress.province,
      postal_code: formData.deliveryAddress.postalCode,
      country: formData.deliveryAddress.country,
    },
    
    // Use new contact arrays
    collection_contacts: collectionContacts,
    delivery_contacts: deliveryContacts,
    
    // Transform parcels
    fulfillment_details: null,
    parcels: formData.parcels.map((parcel, index) => ({
      id: `preview-${index}`,
      parcel_type: parcel.type,
      description: parcel.description,
      weight: parcel.weight,
      dimensions: parcel.dimensions,
      value: parcel.value,
      quantity: parcel.quantity,
      other_type_specification: parcel.otherTypeSpecification || null,
      insurance_enabled: parcel.insuranceEnabled,
    })),
  };
};
